import React from "react";
import Card from "../core/Card";
import PageContainer from "../core/PageContainer";
import { wrapComponentForErrors } from "../utility/ErrorHandler";

const Stepper = React.lazy(() => import("../core/Stepper"));

function ComponentGuide() {
  return (
    <PageContainer>
      <React.Suspense fallback={null}>
        <Card title={"Stepper"}>
          <Stepper
            steps={[{ title: "Do a Thing" }, { title: "Do Another Thing" }]}
          />
        </Card>
      </React.Suspense>
    </PageContainer>
  );
}

export default wrapComponentForErrors(ComponentGuide);



// WEBPACK FOOTER //
// ./app/javascript/components/pages/ComponentGuide.jsx